module.exports = __webpack_public_path__ + "img/search-queries.7aaff979.svg";